import styled from 'styled-components';
import { getCombinedClassNames } from 'utils/style';

const activityTextClass = {
  whistle: 'text-activity-sport',
  flag: 'text-activity-learn',
  confetti: 'text-activity-outing',
  'coffee-cup': 'text-activity-relax',
};

const ActivityThemeWrap = styled.div.attrs(() => {
  const classNameToAdd = ['w-full', 'rounded', 'rounded-lg', 'bg-secondary-300', 'p-4', 'lg:p-14', 'mb-6', 'lg:mb-12'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const ActivityThemeTitle = styled.h2.attrs(() => {
  const classNameToAdd = ['text-base-700', 'text-center'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const ActivityThemeSubtitle = styled.div.attrs(() => {
  const classNameToAdd = [

    'text-lg',
    'text-center',
    'mx-auto',
    'flex',
    'justify-center',
    'w-full',
    'md:w-2/3',
    'mt-4',
    'p-4',
    'pt-0',
  ];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const ActivityThemeItemsWrap = styled.div.attrs(() => {
  const classNameToAdd = ['flex', 'flex-col', 'lg:flex-row', 'lg:justify-center', 'pt-4', 'lg:py-8', 'lg:mx-auto'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const ActivityThemeItem = styled.a.attrs(() => {
  const classNameToAdd = [
    'w-full',
    'lg:w-48',
    'border-b-2',
    'last:border-b-0',
    'lg:border-b-0',
    'border-basic-300',
    'flex',
    'lg:flex-none',
    'lg:block',
    'py-2',
    'lg:mx-4',
    'lg:p-6',
    'lg:first:ml-0',
    'lg:last:mr-0',
    'lg:bg-white',
    'lg:rounded',
    'lg:rounded-xl',
    'last:pb-0',
    'group',
    'cursor-pointer',
  ];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const ActivityThemeIconWrap = styled.div.attrs(({ icon }) => {
  const classNameToAdd = [
    'p-2',
    'rounded-lgPlus',
    'bg-white',
    'h-12',
    'w-12',
    'flex',
    'justify-center',
    'items-center',
    'lg:h-22',
    'lg:w-22',
    'lg:mx-auto',
    activityTextClass[icon],
  ];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const ActivityThemeContent = styled.div.attrs(() => {
  const classNameToAdd = [
    'pl-4',
    'lg:pl-0',
    'lg:flex',
    'lg:items-center',
    'lg:flex-col',
    'lg:text-center',
    'lg:text-lg',
    'lg:leading-5',
  ];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const ActivityThemeAnchor = styled.span.attrs(() => {
  const classNameToAdd = ['text-basic-700', 'font-bold', 'inline-block', 'flex', 'items-center'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

export {
  ActivityThemeWrap,
  ActivityThemeTitle,
  ActivityThemeSubtitle,
  ActivityThemeItemsWrap,
  ActivityThemeItem,
  ActivityThemeIconWrap,
  ActivityThemeContent,
  ActivityThemeAnchor,
};
